<template>
  <iColumn v-bind="myLayoutProps">
    <slot />
  </iColumn>
</template>

<script>
import {
  LayoutElementMixinProduction,
} from "%/dynamic-components/render-engine/components/production/elements/layouts/layout-element-mixin-production";

export default {
  name: "VerticalContainer",
  production: true,
  mixins: [LayoutElementMixinProduction],
};
</script>
